import React from 'react';
import { findWidgetDefinition } from './widgetRegistry';

/**
 * Creates a React element for a widget based on its ID
 * Used when adding new widgets to a dashboard
 * @param widgetId - The widget identifier (e.g., 'allocation', 'risk-alerts')
 * @param newWidgetId - The new unique ID for this widget instance
 * @returns React element for the widget or null if widget type is not recognized
 */
export const createWidgetFromId = (
  widgetId: string,
  newWidgetId: string,
): React.ReactElement | null => {
  const definition = findWidgetDefinition(widgetId);
  if (definition) {
    return definition.createFromId(newWidgetId);
  }
  return null;
};
